import { NavLink } from "react-router-dom";

export default function Sidebar({ sections, footer }) {
  return (
    <aside className="flex h-full w-[215px] shrink-0 flex-col border-r border-(--border-subtle) bg-(--surface-1)">
      <div className="flex shrink-0 items-center px-[22px] pb-[26px] pt-[22px]">
        <div className="flex items-center gap-1.5">
          <span className="text-[19px] font-extrabold tracking-[-0.01em] text-(--text-primary)">
            adlywise
          </span>
          <span className="text-[19px] font-extrabold text-(--brand-primary)">
            DSP
          </span>
        </div>
      </div>

      <nav className="flex-1 overflow-y-auto px-4">
        {sections.map((section, idx) => (
          <div
            key={section.heading ?? `section-${idx}`}
            className={idx > 0 ? "mt-5" : ""}
          >
            {section.heading && (
              <div className="px-[10px] pb-2 text-[10px] font-semibold uppercase tracking-wider text-(--text-muted)">
                {section.heading}
              </div>
            )}
            <ul className="flex list-none flex-col gap-[2px]">
              {section.items.map((item) => (
                <li key={item.to}>
                  <NavLink
                    to={item.to}
                    end={item.end}
                    className={({ isActive }) =>
                      `flex items-center gap-3 rounded-[9px] px-[10px] py-[9px] text-[13px] font-semibold no-underline transition-colors ${
                        isActive
                          ? "bg-(--pastel-violet) text-(--brand-primary)"
                          : "text-(--text-secondary) hover:bg-(--surface-2) hover:text-(--text-primary)"
                      }`
                    }
                  >
                    {item.icon &&
                      (typeof item.icon === "string" ? (
                        <span
                          aria-hidden="true"
                          className="text-lg leading-none"
                        >
                          {item.icon}
                        </span>
                      ) : (
                        <item.icon size={18} strokeWidth={1.7} />
                      ))}
                    <span>{item.label}</span>
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </nav>

      {footer && (
        <div className="border-t border-(--border-subtle) px-5 py-4">
          {footer}
        </div>
      )}
    </aside>
  );
}
